import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussions</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Diversity of the wetland plants</strong>
            </p>
            <p>
              Total seven wetland plant species were collected from Jakkur Lake,
              Bengaluru. Identified plant species are <em>Typha</em> sp. (Figure
              1), <em>Cyperus</em> sp. (Figure 2), <em>Ludwigia</em> sp. (Figure
              3), <em>Pistia stratiotes </em>(Figure 4), <em>Polygonum</em> sp.
              (Figure 5), <em>Alternanthera philoxeroides </em>(Figure 6) and{" "}
              <em>Spirodela</em> sp. (Figure 7). Among these five are emergent (
              <em>Typha </em>sp.,<em> Cyperus </em>sp.,<em> Ludwigia </em>sp.,
              <em> Alternanthera philoxeroides </em>and<em> Polygonum </em>sp.)
              and two are floating wetland plant species (<em>Spirodela </em>sp.
              and <em>Pistia stratiotes</em>).
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;
            </p>
            <p>
              <table align="center">
                <tr>
                  <td>
                    <img src="images/af1.png" alt="Image 1" width="327" />
                  </td>
                  <td>
                    <img src="images/af2.png" alt="Image 2" width="300" />
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "center" }}>
                    Figure 1. <i>Typha</i> species
                  </td>
                  <td style={{ textAlign: "center" }}>
                    Figure 2. <i>Cyperus</i> species
                  </td>
                </tr>

                {/* <!-- Row 3: Images --> */}
                <tr>
                  <td>
                    <img
                      src="images/af3.png"
                      alt="Image 3"
                      width="320"
                      height={280}
                    />
                  </td>
                  <td>
                    <img
                      src="images/af4.png"
                      alt="Image 4"
                      width="300"
                      height={283}
                    />
                  </td>
                </tr>

                {/* <!-- Row 4: Captions --> */}
                <tr>
                  <td style={{ textAlign: "center" }}>
                    Figure 3. <i>Ludwigia</i> species
                  </td>
                  <td style={{ textAlign: "center" }}>
                    Figure 4. <i>Pistia stratiotes</i>{" "}
                  </td>
                </tr>
              </table>
            </p>

            <p style={{ textAlign: "center" }}>
              <img src="images/af5.png" alt="" />
              <br />
              Figure 7. <i>Polygonum</i> sp
            </p>
            <p>
              <strong>Remediation potential of the wetland plants</strong>
            </p>
            <p>
              Copper replaces other co-factors in key enzymes and disrupts
              photosynthetic activity and other cellular processes<sup>20</sup>.
              Lead toxicity causes swollen, bent, short and stubby roots
              <sup>21</sup>. Zinc excess will alter the physiological, ultra
              structural and biochemical parameters of the plants. Excess of Ni
              <sup>2+</sup> causes various physiological alterations and diverse
              toxicity symptoms such as chlorosis and necrosis in the plant
              species<sup>22</sup>. Copper concentration exceeding 20 mg/kg in
              the shoot is injurious, though copper is an essential element for
              growth<sup>23</sup>. The remediation potential of the wetland
              plants collected on weekly basis is represented in Tables 1, 2, 3
              and 4 respectively.
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>
                Table 1. Uptake of heavy metals by the wetland plants (sampling
                done on 17/5/17)
              </strong>
            </p>
            <table align="center" width="661">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="3" width="83">
                    <p>
                      <strong>Plant samples</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="308">
                    <p>
                      <strong>*Inlet</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="270">
                    <p>
                      <strong>*Outlet </strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="308">
                    <p>
                      <strong>Heavy metals (mg/kg)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="270">
                    <p>
                      <strong>Heavy metals (mg/kg)</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="47">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>Cd</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>Cd</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      young <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>17.2</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>14.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5.0</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>1.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>4.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>13.2</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      mature <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>10.0</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      <em>&nbsp;</em>&nbsp;young{" "}
                      <em>Alternanthera philoxeroides </em>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>2.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>5.8</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>10.8</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      medium <em>Polygonum</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>9.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>12.0</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      mature <em>Polygonum</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>3.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.2</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      medium <em>Ludwigia</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>6.2</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>10.6</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.6</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      mature<em> Pistia stratiotes</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>2.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>6.2</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>9.6</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      <em>Spirodela </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>6.8</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>10.6</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>0.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      Normal range<sup>24</sup>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1-5</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>0.2-20</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>1-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.02-5</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.03-14</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.1-2.4</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      Critical range<sup>24</sup>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>30-300</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>100-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10-100</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="83">
                    <p>
                      Threshold effect level<sup>25</sup>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.7</p>
                  </td>
                  <td style={styles.cell} width="59">
                    <p>18.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>123.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>37.3</p>
                  </td>
                  <td style={styles.cell} width="51">
                    <p>0.596</p>
                  </td>
                  <td style={styles.cell} width="44">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>
                Table 2. Uptake of heavy metals by the wetland plants (sampling
                done on 30/5/17)
              </strong>
            </p>
            <table align="center" width="680">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="3" width="104">
                    <p>
                      <strong>Plant samples</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="293">
                    <p>
                      <strong>*Inlet</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="283">
                    <p>
                      <strong>*Outlet</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="293">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                  <td style={styles.cell} colspan="6" width="283">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="47">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      young <em>Typha</em> sp. shoot
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>9.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>9.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>10.4</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>11.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>5.8</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.4</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      medium <em>Typha</em> sp. shoot
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>9.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>9.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      mature <em>Typha</em> sp. shoot
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>8.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>10.0</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>14.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>8.0</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>12.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      mature<em> Alternanthera philoxeroides</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>5.6</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.4</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      mature<em> Pistia stratiotes</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>6.0</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.6</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      <em>Spirodela </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>4.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>13.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Normal range</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1-5</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>0.2-20</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.02-5</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.03-14</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.1-2.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Critical range</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>30-300</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>100-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10-100</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Threshold limit</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.7</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>18.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>123.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>37.3</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.596</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>
                Table 3. Uptake of heavy metals by the wetland plants (sampling
                done on 6/6/17)
              </strong>
            </p>
            <table align="center" width="680">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="3" width="95">
                    <p>
                      <strong>Plant samples</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="265">
                    <p>
                      <strong>*Inlet </strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="321">
                    <p>
                      <strong>*Outlet</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="265">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                  <td style={styles.cell} colspan="6" width="321">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="47">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>
                      medium <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>14.4</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>16.4</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>1.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>
                      mature <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.0</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>4.6</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>1.0</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>13.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>
                      mature<em> Alternanthera philoxeroides</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>2.4</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>6.6</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>3.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.8</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>10.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>
                      <strong>19.6</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>
                      medium <em>Ludwigia</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>2.4</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>12.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>4.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>Normal range</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1-5</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>0.2-20</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>1-400</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>0.02-5</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.03-14</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.1-2.4</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>Critical range</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>30-300</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>100-400</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>10-100</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="95">
                    <p>Threshold limit</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.7</p>
                  </td>
                  <td style={styles.cell} width="43">
                    <p>18.0</p>
                  </td>
                  <td style={styles.cell} width="42">
                    <p>123.0</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>35.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>37.3</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.596</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>
                Table 4. Uptake of heavy metals by the wetland plants (sampling
                done on 13/6/17)
              </strong>
            </p>
            <table align="center" colspan="4" width="671">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="3" width="104">
                    <p>
                      <strong>Plant samples</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="293">
                    <p>
                      <strong>*Inlet </strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="6" width="274">
                    <p>
                      <strong>*Outlet</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="293">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                  <td style={styles.cell} colspan="6" width="274">
                    <p>Heavy metals (mg/kg)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="56">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cu</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Pb</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Zn</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Ni</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>Cr</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>Cd</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      medium <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>2.0</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>5.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      mature <em>Typha</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>1.6</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>6.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>9.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>12.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>23</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.0</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>5.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      young <em>Alternanthera philoxeroides</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>2.2</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>9.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>8.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      medium<em> Alternanthera philoxeroides</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>2.4</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>4.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>
                      medium <em>Ludwigia</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>-</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.2</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>7.8</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>3.4</p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>9.6</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.6</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Normal range</p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>1-5</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>0.2-20</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>1-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.02-5</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.03-14</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.1-2.4</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Critical range</p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>30-300</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>100-400</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>10-100</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>5-30</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="104">
                    <p>Threshold limit</p>
                  </td>
                  <td style={styles.cell} width="56">
                    <p>35.7</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>18.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>123.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>35.0</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>37.3</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>0.596</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="38">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="47">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              *Inlet and outlet are the sampling points at Jakkur Lake,
              Bengaluru.
            </p>
            <p>
              C - Carbon; N - Nitrogen; P - Phosphorus; Cd - Cadmium; Cr -
              Chromium; Ni - Nickel;&nbsp;&nbsp; Zn - Zinc;&nbsp; Cu - Copper;
              Pb - Lead.
            </p>
            <p>
              <strong>
                Metal uptake by wetland plants during the 1<sup>st</sup> week
              </strong>
            </p>
            <p>
              During the 1<sup>st</sup> week of sampling, the uptake of Cu and
              Zn was more by young <em>Typha </em>sp. which was 17.2 and 14.4
              mg/kg, Pb, Ni, Cr and Cd by medium <em>Polygonum</em> sp. which
              was 5.2, 2.4, 12 and 0.8 mg/kg respectively from inlet, whereas
              uptake of Cu was more by mature <em>Pistia stratiotes</em> which
              was 2.6 mg/kg, Pb and Cd by medium <em>Ludwigia</em> sp. which was
              8.4 and 0.6 mg/kg respectively, Zn and Ni by <em>Spirodela</em>{" "}
              sp. which was 8.8 and 6.8 mg/kg and Cr by young <em>Typha</em> sp.
              which was 13.2 mg/kg from outlet (Table 1). The uptake of{" "}
              <strong>Cu </strong>by young <em>Typha</em> sp. from inlet
              exceeded the normal range and uptake of <strong>Ni </strong>by
              young <em>Alternanthera philoxeroides</em>, medium{" "}
              <em>Ludwigia</em> sp., mature <em>Pistia stratiotes</em> and{" "}
              <em>Spirodela </em>sp. from the outlet exceeded the normal range.
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>
                Metal uptake during the 2<sup>nd</sup> week
              </strong>
            </p>
            <p>
              During the 2<sup>nd</sup> week of sampling, the uptake of Cu, Pb,
              Zn and Ni was more by young <em>Typha </em>sp. shoot which was
              1.4, 9.0, 9.4 and 10.0 mg/kg respectively, Cr and Cd by mature{" "}
              <em>Typha </em>sp. shoot which was 14.0 and 0.6 mg/kg respectively
              from inlet, Cu and Cd by mature<em> Pistia stratiotes </em>sp.
              which was 1.2 and 1.6 mg/kg respectively, Pb and Ni by young{" "}
              <em>Typha</em> sp. shoot which was 9.8 and 9.0 mg/kg respectively,
              Zn by mature <em>Alternanthera philoxeroides </em>which was 10.2
              mg/kg and Cr by <em>Spirodela</em> sp. which was 13.6 mg/kg from
              outlet (Table 2). The uptake of <strong>Ni </strong>by young and
              mature <em>Typha</em> sp. shoot from inlet exceeded the normal
              range and uptake of <strong>Ni </strong>by young and mature{" "}
              <em>Typha </em>sp. shoot, mature{" "}
              <em>Alternanthera philoxeroides</em> and mature{" "}
              <em>Pistia stratiotes</em> from the outlet exceeded the normal
              range.
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>
                Metal uptake during the 3<sup>rd</sup> week
              </strong>
            </p>
            <p>
              During the 3<sup>rd</sup> week of sampling, the uptake of Cu, Pb,
              Zn and Cr was more by medium <em>Typha </em>sp. which was 14.4,
              7.6, 16.4 and 6.2 mg/kg respectively, Ni by mature <em>Typha </em>
              sp. which was 4.0 mg/kg and Cd by mature{" "}
              <em>Alternanthera philoxeroides</em> which was1.8 mg/kg from
              inlet. The uptake of Cu was more by medium <em>Ludwigia </em>sp.
              which was 2.4 mg/kg, Pb and Zn by mature <em>Typha</em> sp. which
              was 13.6 and 10.4 mg/kg respectively and Cr by mature{" "}
              <em>Alternanthera philoxeroides </em>which was 19.6 mg/kg from
              outlet (Table 3). The uptake of <strong>Cu </strong>by medium{" "}
              <em>Typha</em> sp. from inlet exceeded the normal range and uptake
              of <strong>Cr </strong>by mature{" "}
              <em>Alternanthera philoxeroides</em> from the outlet exceeded the
              normal range.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>
                Metal uptake by wetland plants during the 4<sup>th</sup> week
              </strong>
            </p>
            <p>
              During the 4<sup>th</sup> week of sampling, the uptake of Cu, Pb,
              Zn and Cr was more by young <em>Alternanthera philoxeroides</em>{" "}
              which was 2.2, 9.8, 8.6 and 10.2 mg/kg respectively, Ni by mature{" "}
              <em>Typha </em>sp. which was 2.2 mg/kg and Cd by medium{" "}
              <em>Typha</em> sp. which was 0.8 mg/kg from inlet. The uptake of
              Cu, Pb, and Cr was more by medium <em>Ludwigia</em> sp. which was
              3.2, 3.4 and 9.6 mg/kg respectively, Pb, Zn and Cd by mature{" "}
              <em>Typha</em> sp. which was 12.2, 23.0 and 1.4 mg/kg respectively
              from outlet (Table 4). The uptake of heavy metals by the
              macrophytes during the 4<sup>th </sup>week was within the normal
              range.
            </p>
            <p>&nbsp;</p>
            <p>
              Wetland plants at storm water detention ponds have showed the
              ability for the uptake of nutrients and heavy metals<sup>26</sup>.{" "}
              <em>Eichhornia</em> sp. uptake heavy metals Pb, Cr, Zn, Mn, and Cu
              to a large extent from the wastewater<sup>27</sup>.{" "}
              <em>Ludwigia natans </em>is useful for remediation of Cd from
              contaminated water<sup>28</sup>. <em>Typha angustifolia</em> has
              been reported to assess remediation of various heavy metals (Cu,
              Pb, Ni, Fe, Mn, and Zn) and found that the plant removes heavy
              metals from industrial wastewater containing metal, melanoidin,
              and phenol compounds<sup>29</sup>. <em>Spirodela </em>sp. has high
              uptake capacity of Cr, Zn and Pb<sup>30</sup>. The analyses
              highlight that using plants for remediation is an environmental
              friendly approach because of high efficiency in metal removal and
              economical<sup>31</sup>.
            </p>
            <p>
              Removal of toxic metals by wetland plants viz.,{" "}
              <em>Phragmites australis</em>, <em>Juncus effusus</em> and{" "}
              <em>Iris pseudacorus</em>
              <sup>32</sup>. <em>Carex pseudocyperus</em> and{" "}
              <em>C. riparia</em> wetland plants have been reported to be
              effective for the removal of metals from water<sup>33</sup>. The
              heavy metal accumulation potential of wetland plants has been
              studied by<sup>34-38</sup>. The spatial pattern of heavy metal
              accumulation in sediments and macrophytes of Bellandur wetland,
              Bangalore, India show higher accumulation of all metals except for
              chromium was found in <em>Typha angustata</em>
              <sup>35</sup>. The bioremediation potential of aquatic macrophytes
              in Jakkur wetland, Bangalore, India is evident with the higher
              concentration of lead, zinc, nickel and chromium in{" "}
              <em>Typha angustatathan</em> at inlet. Nickel above normal range
              was observed in <em>Typha angustata</em> at inlet and in all plant
              species at outlet<sup>36-38</sup>. Similarly, there is a report on
              heavy metals in biotic and abiotic components of Varthur wetlands,
              Bangalore, India<sup>37, 39</sup>. The assessment of
              bioconcentration and translocation factors in macrophytes showed
              the select macrophytes are useful to remove heavy metals
              <sup>37, 38</sup>.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
